/**
 * Ayuna Unified Custom Scripts
 * Refactored for performance and maintainability.
 */

// 1. ACCORDION LOGIC
const initAccordions = () => {
    const accordions = document.querySelectorAll(".accordion");
    if (!accordions.length) return;

    accordions.forEach(accordion => {
        accordion.addEventListener('toggle', function () {
            if (this.open) {
                accordions.forEach(item => {
                    if (item !== this && item.open) item.removeAttribute('open');
                });
            }
        });
    });
};

// 2. EXTERNAL LINKS LOGIC (MENU)
const initExternalLinks = () => {
    const links = document.querySelectorAll('a[href*="ayuna.co"]');
    const currentLang = document.documentElement.lang || "en";

    links.forEach(link => {
        const isTargetPage = ['beautifulness', 'universe', 'universo'].some(key => link.href.includes(key));
        
        if (isTargetPage) {
            link.addEventListener("click", function (e) {
                e.preventDefault();
                let targetUrl = this.href;
                
                if (currentLang.startsWith("es") && !targetUrl.includes('lang=es')) {
                    targetUrl += (targetUrl.includes('?') ? '&' : '?') + 'lang=es';
                }
                window.open(targetUrl, "_blank");
            });
        }
    });
};

// 3. SHOP THE LOOK LOGIC
const initShopTheLook = () => {
    const items = document.querySelectorAll('.shop-the-look__item');
    const prevBtn = document.getElementById('carousel-prev-button');
    const nextBtn = document.getElementById('carousel-next-button');
    
    if (!items.length || !prevBtn || !nextBtn) return;

    const maxItems = items.length; 
    let currentIndex = 0;

    const updateLookDetails = ({ title, description, item }) => {
        const elements = {
            title: document.getElementById('look-title'),
            desc: document.getElementById('look-description'),
            item: document.getElementById('look-item'),
            input: document.getElementById('selected_routine')
        };

        if (elements.title) elements.title.textContent = title || '';
        if (elements.desc) elements.desc.textContent = description || '';
        if (elements.item) elements.item.textContent = item || '';

        if (elements.input && item) {
            const currentNumber = parseInt(item.split('/')[0]);
            if (!isNaN(currentNumber)) elements.input.value = currentNumber - 1;
        }
    };

    const updateDetailsByIndex = (index) => {
        const currentItem = items[index];
        if (!currentItem) return;
        
        updateLookDetails({
            title: currentItem.getAttribute('data-look-title'),
            description: currentItem.getAttribute('data-look-description'),
            item: currentItem.getAttribute('data-look-item'),
        });
    };

    prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        currentIndex = (currentIndex - 1 + maxItems) % maxItems;
        updateDetailsByIndex(currentIndex);
    });

    nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        currentIndex = (currentIndex + 1 + maxItems) % maxItems;
        updateDetailsByIndex(currentIndex);
    });

    // Mobile "Lateral Bounce" Animation
    const carousel = document.querySelector("shop-the-look-mobile-carousel");
    if (carousel) {
        const observer = new IntersectionObserver((entries, obs) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const startAnimation = () => {
                        carousel.classList.remove("lateral-bounce");
                        void carousel.offsetWidth; // Force reflow
                        carousel.classList.add("lateral-bounce");
                    };
                    startAnimation();
                    setInterval(startAnimation, 15000);
                    obs.unobserve(carousel);
                }
            });
        }, { threshold: 0.8 });
        observer.observe(carousel);
    }

    updateDetailsByIndex(currentIndex);
};

/**
 * MASTER INITIALIZATION
 */
const initAll = () => {
    initAccordions();
    initExternalLinks();
    initShopTheLook();
};

// Start when DOM is ready
document.addEventListener("DOMContentLoaded", initAll);

// Re-start when Shopify Theme Editor reloads a section
document.addEventListener('shopify:section:load', (event) => {
    // If the whole page isn't reloaded, we check if the specific section needs a reboot
    const target = event.target;
    if (target.querySelector('.shop-the-look') || target.classList.contains('shop-the-look')) {
        initShopTheLook();
    }
    // Re-init global elements just in case they were part of the section
    initAccordions();
    initExternalLinks();
});